import { TooltipHost } from '@fluentui/react';
import { TableData } from '../Util/TableData';
import { TDataWallet, TCarteraRatioTableProps, TRatiosCarterasData } from '../types/CarteraRatioTypes';

const BASE_CLASS = "ratios_carteras";

const CarteraRatioTable: React.FC<TCarteraRatioTableProps> = ({
    tablePeriod,
    ratios,
}) => {
    const resultTable = TableData({tablePeriod: tablePeriod, ratios: ratios})

    return (
        <div className={BASE_CLASS}>

            <table>
                <thead>
                    <tr>
                        <th>Ratios</th>
                        {ratios?.map((ratiosCartera: TRatiosCarterasData) =>
                            <th>{ratiosCartera.name}</th>
                         )}
                    </tr>
                </thead>
                <tbody>
                    {resultTable?.map((dataWallet: TDataWallet) => (     
                        <tr>
                            <td>
                                <strong>
                                    <TooltipHost content={dataWallet.toolTipHostContent}>
                                        {dataWallet.ratioName}
                                    </TooltipHost>
                                </strong>
                            </td>
                            {dataWallet.data && dataWallet?.data.map((text: string | number) =>
                                <td>
                                    {text}
                                </td>
                            )}

                        </tr>
                        )
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default CarteraRatioTable;